export default class FollowersModel {
    public avatar: string = null;
    public followerId: string = null;
    public name: string = null;
    public nickname: string = null;
    public profileId: string = null;
}